export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-upload-cloud-9ec2a4c51443bcbf8f32a74fb4f1cf77.svg";